const getters = {
  hideInfo: state => state.isLogin.hideInfo,
  isTips: state => state.isLogin.isTips,
  menus: state => state.isLogin.menus,
  panes: state => state.isLogin.panes,
  personalData: state => state.isLogin.personalData,
  activeKey: state => state.isLogin.activeKey,
  meunList: state => state.isLogin.meunList,
  services: state => state.isLogin.services
}

export default getters
